export function formatString(str: string) {
  if (!str) return "";
  const withSpaces = str.replace(/_/g, " ");
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

export const dummyJobs = [
  {
    task_id: "a948fd69-d8f2-4169-be74-50a9ec67d7e8",
    state: "FAILURE",
    filename: "20250731_181020_CG_ Questions  - PANCE.csv",
    current: 0,
    total: 1,
    failed: 0,
    model: "Unknown",
    progress_percent: 0,
    start_time: null,
    end_time: "2025-07-31T23:14:24.849350",
    s3_upload_key: null,
    s3_result_key: null,
    error:
      'Could not connect to the endpoint URL: "https://manual-categorization-ai.s3.us-east-2.amazonaws.com/results/result_a948fd69-d8f2-4169-be74-50a9ec67d7e8.csv"',
    estimated_time_remaining: null,
    worker_name: null,
  },
  {
    task_id: "14fffc9d-3beb-47d1-bd58-f962eb633f40",
    state: "FAILURE",
    filename: "20250731_181205_CG_ Questions .xlsx",
    current: 0,
    total: 1,
    failed: 0,
    model: "Unknown",
    progress_percent: 0,
    start_time: null,
    end_time: "2025-07-31T23:57:01.736868",
    s3_upload_key: null,
    s3_result_key: null,
    error:
      'Could not connect to the endpoint URL: "https://manual-categorization-ai.s3.us-east-2.amazonaws.com/results/result_14fffc9d-3beb-47d1-bd58-f962eb633f40.csv"',
    estimated_time_remaining: null,
    worker_name: null,
  },
  {
    task_id: "9765434f-49f4-4176-b5a7-594f30e50f16",
    state: "FAILURE",
    filename: "20250731_185234_CG_ Questions  - PANCE.csv",
    current: 0,
    total: 1,
    failed: 0,
    model: "Unknown",
    progress_percent: 0,
    start_time: null,
    end_time: "2025-07-31T23:14:24.795896",
    s3_upload_key: null,
    s3_result_key: null,
    error:
      'Could not connect to the endpoint URL: "https://manual-categorization-ai.s3.us-east-2.amazonaws.com/results/result_9765434f-49f4-4176-b5a7-594f30e50f16.csv"',
    estimated_time_remaining: null,
    worker_name: null,
  },
  {
    task_id: "3b7c10c6-f1c4-498a-9855-c32b5d2f3c12",
    state: "SUCCESS",
    filename: "20250801_121741_20-CG_Questions.xlsx",
    current: 19,
    total: 19,
    failed: 0,
    model: "lcme_accreditation_standards",
    progress_percent: 100,
    start_time: "2025-08-01T12:17:45.310294",
    end_time: "2025-08-01T12:21:28.033398",
    s3_upload_key: "uploads/20250801_121741_20-CG_Questions.xlsx",
    s3_result_key: "results/result_3b7c10c6-f1c4-498a-9855-c32b5d2f3c12.csv",
    error: null,
    estimated_time_remaining: null,
    worker_name: null,
  },
  {
    task_id: "8f74c33a-f77f-4262-b7b8-6511b4d43d34",
    state: "SUCCESS",
    filename: "20250801_121741_20-CG_Questions.xlsx",
    current: 0,
    total: 1,
    failed: 0,
    model: "lcme_accreditation_standards",
    progress_percent: 0,
    start_time: "2025-08-01T12:17:45.310294",
    end_time: "2025-08-01T12:21:28.033398",
    s3_upload_key: "uploads/20250801_121741_20-CG_Questions.xlsx",
    s3_result_key: null,
    error: null,
    estimated_time_remaining: null,
    worker_name: null,
  },
  {
    task_id: "26b3e4c7-582f-4701-b189-761557300e8d",
    state: "SUCCESS",
    filename: "20250801_105249_CG_ Questions  - PANCE.csv",
    current: 991,
    total: 991,
    failed: 0,
    model: "aamc_standards",
    progress_percent: 100,
    start_time: "2025-08-01T10:53:07.047517",
    end_time: "2025-08-01T12:02:01.975711",
    s3_upload_key: "uploads/20250801_105249_CG_ Questions  - PANCE.csv",
    s3_result_key: "results/result_26b3e4c7-582f-4701-b189-761557300e8d.csv",
    error: null,
    estimated_time_remaining: null,
    worker_name: null,
  },
  {
    task_id: "b1d45ec3-a950-4480-8a5e-82b19d8a2064",
    state: "SUCCESS",
    filename: "20250801_105249_CG_ Questions  - PANCE.csv",
    current: 0,
    total: 1,
    failed: 0,
    model: "aamc_standards",
    progress_percent: 0,
    start_time: "2025-08-01T10:53:07.047517",
    end_time: "2025-08-01T12:02:01.975711",
    s3_upload_key: "uploads/20250801_105249_CG_ Questions  - PANCE.csv",
    s3_result_key: null,
    error: null,
    estimated_time_remaining: null,
    worker_name: null,
  },
  {
    task_id: "888f6c3b-9848-4185-8acd-260868a2c209",
    state: "SUCCESS",
    filename: "20250801_035938_CG_ Questions  - PANCE.csv",
    current: 991,
    total: 991,
    failed: 0,
    model: "aamc_standards",
    progress_percent: 100,
    start_time: "2025-08-01T03:59:41.658627",
    end_time: "2025-08-01T11:33:51.415634",
    s3_upload_key: "uploads/20250801_035938_CG_ Questions  - PANCE.csv",
    s3_result_key: "results/result_888f6c3b-9848-4185-8acd-260868a2c209.csv",
    error: null,
    estimated_time_remaining: null,
    worker_name: null,
  },
  {
    task_id: "1c7e3e47-b601-4052-9f29-f21777b0ea50",
    state: "SUCCESS",
    filename: "20250801_035938_CG_ Questions  - PANCE.csv",
    current: 0,
    total: 1,
    failed: 0,
    model: "aamc_standards",
    progress_percent: 0,
    start_time: "2025-08-01T03:59:41.658627",
    end_time: "2025-08-01T11:33:51.415634",
    s3_upload_key: "uploads/20250801_035938_CG_ Questions  - PANCE.csv",
    s3_result_key: null,
    error: null,
    estimated_time_remaining: null,
    worker_name: null,
  },
  {
    task_id: "2bb9e763-172c-4989-abf1-825ad31ff361",
    state: "SUCCESS",
    filename: "20250801_015221_CG_ Questions  - PANCE.csv",
    current: 991,
    total: 991,
    failed: 0,
    model: "Unknown",
    progress_percent: 100,
    start_time: "2025-08-01T01:52:25.378889",
    end_time: "2025-08-01T02:56:25.888587",
    s3_upload_key: "uploads/20250801_015221_CG_ Questions  - PANCE.csv",
    s3_result_key: "results/result_2bb9e763-172c-4989-abf1-825ad31ff361.csv",
    error: null,
    estimated_time_remaining: null,
    worker_name: null,
  },
];
